import { useState, useEffect, useContext, createContext, useRef } from "react"
import { initializeChannel } from "../utils/message.service"

const Context = createContext()

const session = {}

export const useSession = () => useContext(Context)

export const getSession = function () {
  const { user_name, user_id, token, client_id } = session
  return {
    user_name,
    user_id,
    token,
    client_id,
  }
}

const handleInvalidSession = () => {
  const { user_name, user_id, token, client_id } = getSession()
  const usernameValid = user_name ? user_name.length > 0 : false
  const userIdValid = user_id > 0
  const tokenValid = token ? token.length > 0 : false
  const clientIdValid = client_id ? client_id.length === 6 : false
  if (!usernameValid || !tokenValid || !userIdValid || !clientIdValid) {
    console.error("invalid session", { usernameValid, tokenValid, userIdValid, clientIdValid })
  }
}

export const SessionProvider = ({ children }) => {
  let mounted = useRef(true)
  const [hasSession, setHasSession] = useState(false)
  const [username, setUsername] = useState(false)
  const [userId, setUserId] = useState(false)
  const [clientId, setClientId] = useState(false)

  useEffect(async () => {
    mounted &&
      initializeChannel((message) => {
        const { data } = message
        session.user_name = data.userName
        session.user_id = data.userId
        session.token = data.sessionToken
        session.client_id = data.clientId
        setUsername(data.userName)
        setUserId(data.userId)
        setClientId(data.clientId)
        setHasSession(true)
        handleInvalidSession()
      })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <Context.Provider value={{ hasSession, username, userId, clientId }}>
      {children}
    </Context.Provider>
  )
}
